/* eslint-disable padding-line-between-statements */
import { Axios } from "./axiosInstance.js";
import configSettings from "../config.js";

const baseUrl = configSettings.vendorPortalBaseUrl;

export const getActionRequestDetails = (id) => {
  const url = `${baseUrl}Actionrequest/getactionrequest?actionrequestid=${id}`;
  return Axios.createInstanceWithApiKey().get(url);
};

export const vendorApprovedActionRequest = (payload) => {
  const url = `${baseUrl}ActionRequest/Approve`;
  return Axios.createInstanceWithApiKey().post(url, payload);
};

export const vendorRequestEditsOnActionRequest = (payload) => {
  const url = `${baseUrl}ActionRequest/RequestEdits`;
  return Axios.createInstanceWithApiKey().post(url, payload);
};
